<template>
  <v-icon :color="checked ? 'green' : 'red'" v-if="icon">
    {{ checked ? "mdi-check" : "mdi-close-thick" }}
  </v-icon>
  <span v-else :class="`${checked ? 'green' : 'red'}--text`">{{
    checked ? "SI" : "NO"
  }}</span>
</template>

<script>
export default {
  name: "check-icon",
  props: { checked: Boolean, icon: { type: Boolean, default: false } },
};
</script>

<style>
</style>